module.exports = __webpack_public_path__ + "media/04 anticipate.07cd774c.mp3";